<template>
  <div class="multi-factor-authentication-container">
    <div class="multi-factor-authentication-button-wrapper">
      <BrandButton
        @click="openModal(mfaEnabled ? 'deactivate' : 'activate')"
        shape="rounded"
        class="multi-factor-authentication-button"
        :radius="50"
      >
        <VueText :isSingleLine="true" color="white-100" sizeLevel="4" weightLevel="2">
          İki Aşamalı Giriş
        </VueText>
      </BrandButton>
      <VueIcon
        v-if="mfaEnabled"
        iconColor="#d02d2c"
        :width="30"
        :height="30"
        :iconName="mfaIcon.name"
        class="mfa-complete-tick"
      />
    </div>

    <div v-if="showModal" class="modal-overlay" @click="closeModal"></div>

    <transition name="fade">
      <div v-if="showModal" class="modal-wrapper">
        <div class="modal-content">
          <button class="modal-close" @click="closeModal">&times;</button>
          <MultiFactorAuthenticationPopup
            v-if="!showVerifyModal"
            @close="closeModal"
            @send="openVerifyModal"
            :selectedPhone="selectedPhone"
            :mode="currentMode"
          />
          <MultiFactorAuthenticationVerifyPopup
            v-else
            :key="verifyModalKey"
            @close="closeModal"
            @verify="handleVerify"
            :selectedPhone="selectedPhone"
            :mode="currentMode"
            :expire-date="expireDate"
          />
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import VueText from '@/components/shared/VueText/VueText.vue';
import BrandButton from '@/components/brand/BrandButton/BrandButton';
import MultiFactorAuthenticationPopup from './MultiFactorAuthenticationPopup.vue';
import MultiFactorAuthenticationVerifyPopup from './MultiFactorAuthenticationVerifyPopup.vue';
import VueIcon from '@/components/shared/VueIcon/VueIcon.vue';
import { ICON_VARIABLES } from '@/constants/component.constants.js';
import Mfa from '@/services/Api/mfa';

export default {
  name: 'MultiFactorAuthentication',
  components: {
    VueText,
    BrandButton,
    MultiFactorAuthenticationPopup,
    MultiFactorAuthenticationVerifyPopup,
    VueIcon,
  },
  props: {
    userPhone: {
      type: Object,
      default: () => ({ phone: '****' }),
    },
  },
  data() {
    return {
      showModal: false,
      showVerifyModal: false,
      mfaEnabled: false,
      currentMode: 'activate',
      verifyModalKey: 0,
      expireDate: null,
    };
  },
  created() {
    this.fetchMfaStatus();
  },
  methods: {
    fetchMfaStatus() {
      Mfa.getMfaStatus()
        .then(res => {
          this.mfaEnabled = Boolean(res?.data?.Data?.isMfaEnabled);
        })
        .catch(() => {
          this.mfaEnabled = false;
        });
    },
    openModal(mode) {
      this.currentMode = mode;
      this.showVerifyModal = false;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.showVerifyModal = false;
    },
    openVerifyModal({ expireDate }) {
      this.expireDate = expireDate;
      this.verifyModalKey += 1;
      this.showVerifyModal = true;
    },
    handleVerify() {
      this.mfaEnabled = this.currentMode === 'activate';
      this.closeModal();
    },
  },
  computed: {
    selectedPhone() {
      return this.userPhone;
    },
    mfaIcon() {
      return ICON_VARIABLES.checked;
    },
  },
};
</script>

<style scoped lang="scss">
.multi-factor-authentication-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  .multi-factor-authentication-button-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
  }

  .multi-factor-authentication-button {
    width: 150px !important;
    height: 30px !important;
  }

  .mfa-complete-tick {
    position: absolute;
    top: -6px;
    right: -15px;
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
  }

  .modal-wrapper {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    padding: 30px;
    max-width: 450px;
    width: 90%;

    .modal-close {
      position: absolute;
      top: 10px;
      right: -7px;
      background: none;
      border: none;
      font-size: 28px;
      cursor: pointer;
      color: #79838e;
      transition: color 0.2s;

      &:hover {
        color: #000;
      }
    }

    .modal-content {
      position: relative;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
